<template>
    <div class="view-login view">
        <loginHeader />
        <div class="banner-container">
            <el-carousel
                id="carousel"
                :interval="5000"
                :indicator-position="!ads || ads.length <= 1 ? 'none' : ''"
                :arrow="!ads || ads.length <= 1 ? 'never' : 'hover'"
            >
                <template v-if="!ads || ads.length == 0">
                    <el-carousel-item>
                        <div class="login-ad">
                            <img
                                src="@/assets/img/loginPage/login_background.png"
                                style="height: 100%; width: 100%"
                            />
                        </div>
                    </el-carousel-item>
                </template>
                <template v-else>
                    <el-carousel-item v-for="item in ads" :key="item.imgid">
                        <div class="login-ad">
                            <template v-if="!item.imgid">
                                <img
                                    src="@/assets/img/loginPage/login_background.png"
                                    style="height: 100%; width: 100%"
                                />
                            </template>
                            <template v-else>
                                <a
                                    v-if="item.linkurl"
                                    :href="item.linkurl"
                                    :target="item.opentype !== '3' ? '_self' : '_blank'"
                                >
                                    <img
                                        :src="item.imgid"
                                        style="height: 100%; width: 100%"
                                        v-on:error="handleError"
                                    />
                                </a>
                                <div>
                                    <img
                                        :src="item.imgid"
                                        style="height: 100%; width: 100%"
                                        v-on:error="handleError"
                                    />
                                </div>
                            </template>
                        </div>
                    </el-carousel-item>
                </template>
            </el-carousel>
            <div class="login-main">
                <div class="login-comp-container">
                    <!-- <div class="login-panel" :style="{ top: login_top + 'px' }"> -->
                    <div class="login-panel">
                        <div class="login-body">
                            <div
                                class="login-cert-type"
                                :class="{
                                    'web-query-tabs': $util.isOrgProductQueryLoginEnabled()
                                }"
                            >
                                <template v-if="$util.isOrgProductQueryLoginEnabled()">
                                    <div
                                        class="login-mode-tab"
                                        :class="{ active: loginMode === 'personal' }"
                                        v-on:click="switchLoginMode('personal')"
                                    >
                                        个人登录
                                    </div>
                                    <div
                                        class="login-mode-tab"
                                        :class="{ active: loginMode === 'orgProduct' }"
                                        v-on:click="switchLoginMode('orgProduct')"
                                    >
                                        机构/产品登录
                                    </div>
                                </template>
                                <div v-else class="left-btn">个人登录</div>
                                <!-- <div v-if="$const.institutionaLogin" class="middle-line"></div>
                                <div
                                    v-if="$const.institutionaLogin"
                                    class="right-btn"
                                    v-on:click="jumpToInstitutionaLogin"
                                >
                                    机构登录
                                </div> -->
                            </div>
                            <div class="login-form">
                                <el-form
                                    ref="loginForm"
                                    :rules="rules"
                                    :model="loginForm"
                                    label-width="0"
                                    v-on:keyup.enter.native="login"
                                >
                                    <el-form-item
                                        v-if="!isOrgProductLogin && loginCertType === '1'"
                                        label=""
                                        prop="phone"
                                    >
                                        <el-input
                                            v-model.trim="loginForm.phone"
                                            :maxlength="11"
                                            placeholder="请输入手机号码"
                                            prefix-icon="fa fa-mobile"
                                        />
                                    </el-form-item>
                                    <el-form-item
                                        v-if="!isOrgProductLogin && loginCertType === '1'"
                                        label=""
                                        prop="smscode"
                                    >
                                        <el-input
                                            v-model.trim="loginForm.smscode"
                                            class="reset-pwd"
                                            :maxlength="6"
                                            placeholder="请输入验证码"
                                            prefix-icon="fa fa-lock"
                                        >
                                            <span
                                                slot="append"
                                                type="text"
                                                class="reset-btn"
                                                :class="{ grey: count > 0 }"
                                                v-on:click="getVerifyCode"
                                            >
                                                {{
                                                    count > 0 ? `重新获取(${count}s)` : "获取验证码"
                                                }}
                                            </span>
                                        </el-input>
                                    </el-form-item>
                                    <el-form-item
                                        v-if="
                                            !isOrgProductLogin &&
                                            !automaticrecognition &&
                                            loginCertType === '2'
                                        "
                                        label=""
                                        prop="certType"
                                        class="icon-select"
                                    >
                                        <i class="fa fa-id-card select-card" aria-hidden="true" />
                                        <el-select
                                            v-model="loginForm.certType"
                                            placeholder="请选择证件类型"
                                            v-on:change="checkCertNoAgain"
                                        >
                                            <el-option
                                                v-for="item in certTypes"
                                                :key="item.subitem"
                                                :label="item.subitemname"
                                                :value="item.subitem"
                                            />
                                        </el-select>
                                    </el-form-item>
                                    <el-form-item
                                        v-if="isOrgProductLogin"
                                        label=""
                                        prop="accountType"
                                        class="icon-select"
                                    >
                                        <i class="fa fa-user select-card" aria-hidden="true" />
                                        <el-select
                                            v-model="loginForm.accountType"
                                            placeholder="请选择账户类型"
                                            v-on:change="handleAccountTypeChange"
                                        >
                                            <el-option
                                                v-for="item in accountTypes"
                                                :key="item.value"
                                                :label="item.label"
                                                :value="item.value"
                                            />
                                        </el-select>
                                    </el-form-item>
                                    <el-form-item
                                        v-if="isOrgProductLogin"
                                        label=""
                                        prop="certType"
                                        class="icon-select"
                                    >
                                        <i class="fa fa-id-card select-card" aria-hidden="true" />
                                        <el-select
                                            v-model="loginForm.certType"
                                            placeholder="请选择证件类型"
                                            v-on:change="checkCertNoAgain"
                                        >
                                            <el-option
                                                v-for="item in orgProductCertTypes"
                                                :key="item.subitem"
                                                :label="item.subitemname"
                                                :value="item.subitem"
                                            />
                                        </el-select>
                                    </el-form-item>
                                    <el-form-item
                                        v-if="isOrgProductLogin || loginCertType === '2'"
                                        label=""
                                        prop="certNo"
                                    >
                                        <el-input
                                            v-model.trim="loginForm.certNo"
                                            :maxlength="20"
                                            :placeholder="certNoPlaceholder"
                                            prefix-icon="fa el-icon-user-solid"
                                        />
                                    </el-form-item>
                                    <el-form-item
                                        v-if="
                                            showImgCode &&
                                            (isOrgProductLogin || loginCertType === '2')
                                        "
                                        label=""
                                        prop="verifyCode"
                                    >
                                        <el-input
                                            v-model="loginForm.verifyCode"
                                            placeholder="请输入验证码"
                                            :maxlength="4"
                                            prefix-icon="fa fa-shield"
                                        >
                                            <span slot="append" class="prop-verify">
                                                <img
                                                    id="verifyImg"
                                                    :src="imgSrc"
                                                    v-on:click="refresh"
                                                />
                                            </span>
                                        </el-input>
                                    </el-form-item>
                                    <el-form-item
                                        v-if="isOrgProductLogin || loginCertType === '2'"
                                        label=""
                                        prop="password"
                                    >
                                        <div ref="passwordField" class="password-field-wrap">
                                            <el-input
                                                ref="passwordInput"
                                                v-model.trim="loginForm.password"
                                                :type="pwdType"
                                                class="reset-pwd"
                                                :maxlength="32"
                                                placeholder="请输入密码"
                                                prefix-icon="fa fa-lock"
                                                v-on:keydown.native="detectCapsLock"
                                            >
                                                <template slot="suffix">
                                                    <span class="password-actions" v-on:click.stop>
                                                        <i
                                                            :class="iconCla"
                                                            class="password-toggle"
                                                            aria-hidden="true"
                                                            :title="
                                                                pwdType === 'text'
                                                                    ? '隐藏密码'
                                                                    : '显示密码'
                                                            "
                                                            v-on:click="pwdTypeChange"
                                                        />
                                                    </span>
                                                </template>
                                                <template slot="append">
                                                    <div
                                                        class="password-append-area"
                                                        v-on:click.stop="toggleSoftKeyboard"
                                                    >
                                                        <i
                                                            class="fa fa-keyboard-o password-keyboard-btn"
                                                            aria-hidden="true"
                                                            title="打开软键盘"
                                                        />
                                                    </div>
                                                </template>
                                            </el-input>
                                            <div
                                                v-if="isKeyboardVisible"
                                                class="soft-keyboard"
                                                :style="softKeyboardStyle"
                                                v-on:click.stop
                                            >
                                                <div
                                                    v-for="(row, rowIndex) in softKeyboardRows"
                                                    :key="'row-' + rowIndex"
                                                    class="soft-keyboard-row"
                                                >
                                                    <button
                                                        v-for="key in row"
                                                        :key="key.value + '-' + rowIndex"
                                                        type="button"
                                                        class="soft-keyboard-key"
                                                        :class="[
                                                            key.type ? 'key-' + key.type : '',
                                                            key.value === ' ' ? 'key-space' : ''
                                                        ]"
                                                        v-on:click="handleSoftKeyboardKey(key)"
                                                    >
                                                        {{ getSoftKeyboardLabel(key) }}
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                        <div
                                            class="capsLock-tip js-capsLock"
                                            :class="{ hide: !capsLock }"
                                        >
                                            <i class="capsLockTip-triangle" aria-hidden="true" />
                                            大写锁定已打开
                                        </div>
                                    </el-form-item>
                                    <div v-if="isPersonalTradeMode" class="login-action-row">
                                        <div class="resetlogin-btn" v-on:click.once="forgetPwd">
                                            忘记密码
                                        </div>
                                        <div
                                            v-if="$util.getBusinessModule('0A1')"
                                            class="openAcconunt-btn"
                                            v-on:click="register"
                                        >
                                            {{ registerText }}
                                        </div>
                                    </div>
                                    <div
                                        v-if="
                                            $cache.getCompanyInfoParam('10105013') == '1' &&
                                            isPersonalTradeMode
                                        "
                                        class="wx-quick-login"
                                        v-on:click="loginFromWX()"
                                    >
                                        <img src="@/assets/img/loginPage/weixinicon.png" />
                                        <span>微信快捷登录</span>
                                    </div>

                                    <el-form-item v-if="protocol.length > 0" class="protocol">
                                        <div class="privacy-agreement">
                                            <el-checkbox
                                                v-model="checkbox"
                                                size="small"
                                            ></el-checkbox>
                                            <span class="grey">我已阅读并同意:</span>
                                            <span v-for="item in protocol" :key="item.id">
                                                <a
                                                    v-if="item.opentype === '1'"
                                                    class="red"
                                                    :href="$util.imgSrc({ fileCode: item.fileid })"
                                                    target="_blank"
                                                >
                                                    《{{ item.title }}》
                                                </a>
                                                <span v-else class="red" v-on:click="argRead(item)">
                                                    《{{ item.title }}》
                                                </span>
                                            </span>
                                        </div>
                                    </el-form-item>
                                    <el-form-item class="login-btn" style="margin-top: 12px">
                                        <el-button
                                            type="primary"
                                            class="login-n"
                                            :class="span24"
                                            v-on:click="login"
                                        >
                                            立即登录
                                        </el-button>
                                    </el-form-item>
                                </el-form>
                            </div>
                            <div v-if="loginRedirectAddress.length > 0" class="login-redirect">
                                <div
                                    v-for="(item, index) in loginRedirectAddress"
                                    :key="index"
                                    class="item"
                                    v-on:click="$util.openLink(item.address)"
                                >
                                    {{ item.name }}
                                </div>
                            </div>
                            <div
                                v-if="$util.getConfig().hideFunc && showTradeNotice"
                                class="bottom-click-type"
                            >
                                <div
                                    v-if="showTradeNotice"
                                    class="left-btn"
                                    v-on:click="$util.openLink($const.zxTradingNoticeLink)"
                                >
                                    交易须知
                                </div>
                                <!-- <div class="middle-line"></div>
                                <div class="right-btn">帮助手册</div>
                                <div class="middle-line"></div>
                                <div class="right-btn">操作演示</div> -->
                            </div>
                        </div>
                        <div v-if="$cache.getCompanyInfoParam('10109008')" class="forget-password">
                            若您在腾讯理财通、蚂蚁财富等互联网第三方平台或银行购买过【{{
                                $cache.getCompanyInfoParam("10101014")
                            }}】产品，请点击
                            <span class="link" v-on:click="handleRetiredPwd">获取登录密码</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <zx-footer></zx-footer>
        <img-code
            v-if="loginCertType === '1'"
            :dialog-visible="dialogVisible"
            :biztype="$const.IMG_BIZTYPE.SMSLOGIN"
            v-on:verify-in="sendSms"
        />
        <smsValid
            :dialog-visible="smsVisible"
            sms-type="1"
            :mobileno="mobileno"
            :en-mobileno="en_mobileno"
            :certificateno="loginForm.certNo"
            :show-remote="showRemote"
            :biz-type="$const.IMG_BIZTYPE.TWOFACTORAUTH"
            v-on:sms-comfirm="formValidSuccess('1')"
            v-on:close="smsVisible = false"
        />
        <my-dialog
            :title="agrData.title"
            :visible.sync="agrVisible"
            :dialog-close="agrVisibleHdie"
            width="800px"
        >
            <div class="protocol-detail" v-html="agrData.content"></div>
            <div class="align-c">
                <el-button type="primary" style="width: 180px" v-on:click="agrVisible = false">
                    确定
                </el-button>
            </div>
        </my-dialog>
    </div>
</template>

<script>
import loginHeader from "@/components/layout/loginHeader.vue";
import zxFooter from "@/components/layout/zxFooter.vue";
import userApi from "@/api/user";
import fundApi from "@/api/fund";
import imgCode from "@/components/layout/imgCode.vue";
import commonApi from "@/api/common";
import smsValid from "@/components/form/smsValid.vue";
import myDialog from "@/components/layout/myDialog.vue";
import { sceneEnum } from "@/util/util_jfit";
import { clearUrlQuery } from "@/util/url.js";
export default {
    components: {
        zxFooter,
        loginHeader,
        imgCode,
        smsValid,
        myDialog
    },
    data() {
        return {
            imgRefresh: null,
            ad_ratio: 3, // 轮播广告图片的长宽比
            ad_width: 0,
            ad_height: 0, // 轮播广告图片高度，由setPageSize方法计算后赋值
            login_top: "10",
            ads: [],
            loginType: [
                { id: "1", name: "手机号登录" },
                { id: "2", name: "证件号登录" } // 暂不支持其他登录方式
            ],
            loginMode: "personal",
            accountTypes: [
                { value: "institution", label: "机构户", invtp: "0" },
                { value: "product", label: "产品户", invtp: "2" }
            ],
            /* { id: "1", val: "QQ账号", url: "qq_icon" }, */
            others: [{ id: "2", val: "微信登录", url: "wx_icon", name: "wxbind" }],
            certTypes: [], // 证件类型
            loginForm: {
                phone: "",
                password: "",
                smscode: "",
                verifyCode: "",
                accountType: "institution",
                certType: "00",
                certNo: ""
            },
            imgSrc: "",
            loginUser: "enduser",
            loginCertType: "",
            capsLock: false,
            pwdType: "password",
            iconCla: "fa fa-eye-slash",
            isKeyboardVisible: false,
            keyboardUppercase: false,
            softKeyboardLetters: [],
            softKeyboardNumbers: [],
            softKeyboardSymbols: [],
            softKeyboardStyle: {},
            rules: {
                phone: [
                    {
                        required: true,
                        message: "请输入手机号码",
                        trigger: "blur"
                    },
                    { validator: this.$util.validateMobile, trigger: "blur" }
                ],
                certType: [
                    {
                        required: true,
                        message: "请选择证件类型",
                        trigger: "change"
                    }
                ],
                accountType: [
                    {
                        required: true,
                        message: "请选择账户类型",
                        trigger: "change"
                    }
                ],
                certNo: [{ validator: this.checkCertNo, trigger: "blur" }],
                password: [{ required: true, message: "请输入密码", trigger: "blur" }],
                smscode: [
                    {
                        validator: this.$util.validateVerifyCode,
                        trigger: "blur"
                    }
                ],
                verifyCode: [
                    {
                        validator: this.$util.validateImgVerifyCode,
                        trigger: "blur"
                    }
                ]
            },
            /* wx跳转 */
            wxLoginParam: {},
            timer: "",
            count: -1,
            locked: false,
            loginloading: false,
            registerFlag: false,
            defaultImg: require("@/assets/img/loginPage/login_background.png"),
            dialogVisible: false,
            smsVisible: false,
            mobileno: "",
            en_mobileno: "",
            protocol: [],
            agrType: sceneEnum.login, // 协议类型，登录协议
            checkbox: false, // 阅读确认
            agrData: {},
            agrVisible: false,
            showRemote: false,
            showImgCode: false,
            showTradeNotice: false,
            automaticrecognition: false, // 证件类型自动识别
            isRealtaXjb: false, // cfgFundrealtimeQueryAll接口是否有数据（区分实时TA现金宝和普通现金宝）
            loginRedirectAddress: [], // 登录页跳转地址
            twoFactorLoginData: null // 用来缓存首次 login 返回的数据
        };
    },
    computed: {
        isOrgProductLogin() {
            return this.loginMode === "orgProduct";
        },
        isPersonalTradeMode() {
            return !this.isOrgProductLogin && !this.$util.isWebQueryMode();
        },
        orgProductCertTypes() {
            const dictItem = this.loginForm.accountType === "product" ? "131008" : "130008";
            const dictList = this.$cache.getDict(dictItem) || [];
            const certTypes = JSON.parse(JSON.stringify(dictList)).filter((item) => {
                return item.subitem !== "000" && item.subitemname !== "基金账号";
            });
            certTypes.unshift({
                dictitem: dictItem,
                subitem: "000",
                subitemname: "基金账号",
                sysid: "4"
            });
            return certTypes;
        },
        certNoPlaceholder() {
            if (this.loginForm.certType === "000") {
                return "请输入基金账号";
            }
            if (this.isOrgProductLogin) {
                return "请输入证件号码";
            }
            return this.automaticrecognition ? "请输入手机号/证件号/基金账号" : "请输入证件号码";
        },
        span24() {
            return this.registerFlag ? "" : "span-24";
        },
        // 注册方式
        registerType() {
            return this.$cache.getCompanyInfoParam("10109007");
        },
        registerText() {
            return this.registerType === "1" ? "免费注册" : "立即开户";
        },
        softKeyboardRows() {
            const letters = this.softKeyboardLetters.length
                ? this.softKeyboardLetters
                : "qwertyuiopasdfghjklzxcvbnm".split("");
            const numbers = this.softKeyboardNumbers.length
                ? this.softKeyboardNumbers
                : "7401286359".split("");
            const symbols = this.softKeyboardSymbols.length
                ? this.softKeyboardSymbols
                : ["&", "+", "@", "^", "_", "%", "!", "$", "(", "#", "*", ")"];
            const formatLetter = (value) =>
                this.keyboardUppercase ? value.toUpperCase() : value.toLowerCase();
            const letterRow1 = letters
                .slice(0, 10)
                .map((value) => ({ value: formatLetter(value) }));
            const letterRow2 = letters
                .slice(10, 19)
                .map((value) => ({ value: formatLetter(value) }));
            const letterRow3 = letters.slice(19).map((value) => ({ value: formatLetter(value) }));

            return [
                symbols.map((value) => ({ value })),
                numbers
                    .map((value) => ({ value }))
                    .concat([{ value: "backspace", type: "backspace" }]),
                letterRow1.concat([{ value: "shift", type: "shift" }]),
                letterRow2.concat([{ value: "clear", type: "clear" }]),
                letterRow3.concat([
                    { value: "close", type: "close" },
                    { value: "confirm", type: "confirm" }
                ])
            ];
        }
    },
    created() {
        sessionStorage.setItem("alreadyread", "");
        sessionStorage.removeItem("daystoexpiredFlag");
        this.getImgInfo();
        this.$cache.initCityCountyList();
        if (this.$util.getConfig().onlyPrivateFund) {
            this.loginType.length = 1;
        }

        // 是否展示交易须知
        this.showTradeNotice =
            this.$cache.getParamValue("account_info") &&
            this.$cache.getParamValue("account_info").showtradenotice;
    },
    mounted() {
        window.addEventListener("resize", this.updateSoftKeyboardPosition);
        window.addEventListener("scroll", this.updateSoftKeyboardPosition, true);
        this.automaticrecognition = this.$cache.getCompanyInfoParam("10114003") == "1";
        // this.smsVisible = true; // 临时代码
        this.showImgCode = sessionStorage.getItem("showImgCode") === "1";
        if (this.showImgCode) {
            this.$nextTick(() => {
                this.refresh();
            });
        }
        document.body.onresize = (function (o) {
            return function () {
                o.setPageSize();
            };
        })(this);
        this.certTypes = (this.$cache.getDict("130007") &&
            JSON.parse(JSON.stringify(this.$cache.getDict("130007")))) || [
            {
                dictitem: "130007",
                itemorder: 0,
                itemtype: null,
                subitem: "00",
                subitemname: "身份证",
                sysid: 100
            }
        ];
        this.certTypes = this.certTypes.concat([
            {
                dictitem: "130007",
                subitem: "000",
                subitemname: "基金账号",
                sysid: "4"
            }
        ]);
        let findIndex = this.certTypes.findIndex((item) => item.subitem === `00`);
        if (findIndex >= 0) {
            this.certTypes[findIndex].subitemname = `身份证/手机号`;
        }
        if (
            this.$cache.getParams().function_mask &&
            this.$cache.getParams().function_mask.indexOf("0") > -1
        ) {
            this.loginType = this.loginType.filter((item) => {
                return item.id != "1";
            });
        }
        this.getRedirectUrls();
        this.setPageSize();
        // 前端心跳-每隔3分钟刷新验证码图片，以达到登录页面用不超时的效果
        this.imgRefresh = setInterval(
            (function (o) {
                return function () {
                    o.refresh();
                };
            })(this),
            3 * 60 * 1000
        );
        this.getUrlParam();
        this.checkEncWay();
        this.loginCertType = this.$util.getConfig().isPhoneLog ? "1" : "2";
        if (this.loginCertType === "2") {
            this.refresh();
        }
        this.getAgreement();
        // 查询现金宝信息
        this.combQueryFundlist();
        sessionStorage.removeItem("_showSpecial");
    },
    beforeDestroy() {
        clearInterval(this.imgRefresh);
        window.removeEventListener("resize", this.updateSoftKeyboardPosition);
        window.removeEventListener("scroll", this.updateSoftKeyboardPosition, true);
    },
    methods: {
        switchLoginMode(mode) {
            if (this.loginMode === mode) return;
            if (mode === "orgProduct" && !this.$util.isOrgProductQueryLoginEnabled()) return;
            this.loginMode = mode;
            this.loginForm.certNo = "";
            this.loginForm.password = "";
            this.loginForm.verifyCode = "";
            this.isKeyboardVisible = false;
            this.keyboardUppercase = false;
            this.softKeyboardStyle = {};
            this.pwdType = "password";
            this.iconCla = "fa fa-eye-slash";
            if (this.isOrgProductLogin) {
                this.loginForm.accountType = this.loginForm.accountType || "institution";
                this.setOrgProductDefaultCertType();
            } else {
                this.loginForm.certType = this.certTypes[0] ? this.certTypes[0].subitem : "00";
            }
            this.$nextTick(() => {
                this.$refs.loginForm && this.$refs.loginForm.clearValidate();
            });
        },
        handleAccountTypeChange() {
            this.loginForm.certNo = "";
            this.setOrgProductDefaultCertType();
            this.$nextTick(() => {
                this.$refs.loginForm && this.$refs.loginForm.clearValidate(["certType", "certNo"]);
            });
        },
        setOrgProductDefaultCertType() {
            const certTypes = this.orgProductCertTypes;
            this.loginForm.certType = certTypes[0] ? certTypes[0].subitem : "000";
        },
        getRedirectUrls() {
            const paramValue = this.$cache.getCompanyInfoParam("10105012") || "";
            if (paramValue) {
                try {
                    this.loginRedirectAddress = JSON.parse(paramValue);
                } catch (e) {
                    this.loginRedirectAddress = [];
                }
            }
        },
        agrVisibleHdie() {
            this.agrVisible = false;
        },
        argRead(item) {
            this.agrVisible = true;
            this.agrData = item;
        },
        getAgreement() {
            this.$util.getProtocol(this.agrType).then((res) => {
                this.protocol = res;
            });
        },
        // 查询现金宝信息
        async combQueryFundlist() {
            if (this.$util.xjbIsOpen()) {
                try {
                    const [fundRes, realtimeRes] = await Promise.all([
                        fundApi.combQueryFundlist({
                            busiflag: "3",
                            invtp: "1"
                        }),
                        fundApi.cfgFundrealtimeQueryAll()
                    ]);

                    const data = fundRes && fundRes.data;
                    const returnList = data && data.returnList;
                    const xjbFundInfo =
                        returnList && returnList.length > 0 && returnList[0] ? returnList[0] : {};
                    const realtimeData = realtimeRes && realtimeRes.data;

                    this.isRealtaXjb = !!(realtimeData && realtimeData.length);
                    sessionStorage.setItem("xjbFundInfo", JSON.stringify(xjbFundInfo));
                    localStorage.setItem("xjbFundInfo", JSON.stringify(xjbFundInfo));
                    sessionStorage.setItem("_isRealtaXjb", JSON.stringify(this.isRealtaXjb));
                    localStorage.setItem("_isRealtaXjb", JSON.stringify(this.isRealtaXjb));
                } catch (err) {
                    console.error("combQueryFundlist error:", err);
                    this.isRealtaXjb = false;
                    sessionStorage.setItem("xjbFundInfo", JSON.stringify({}));
                    localStorage.setItem("xjbFundInfo", JSON.stringify({}));
                    sessionStorage.setItem("_isRealtaXjb", JSON.stringify(false));
                    localStorage.setItem("_isRealtaXjb", JSON.stringify(false));
                } finally {
                    // 获取基金公司现金宝的名字
                    const obj = this.$cache.getParamValue("fund_info");
                    const xjbName = (obj && obj.xjbname) || "鐜伴噾瀹?";
                    localStorage.setItem("xjbName", xjbName);
                    sessionStorage.setItem("xjbName", (obj && obj.xjbname) || "现金宝");
                }
            }
        },
        /* 处理banner宽度和高度 */
        setPageSize() {
            let w = document.documentElement.clientWidth || document.body.clientWidth;
            w = w < 1200 ? 1200 : w;
            this.ad_width = w;
            this.ad_height = w / this.ad_ratio;
            if (this.ad_height < 500) {
                this.ad_height = 500;
                this.ad_width = this.ad_height * this.ad_ratio;
            }
            // 登录表单位置计算
            this.login_top = (this.ad_height - 470) / 2;
        },
        /* 校验证件号码 */
        checkCertNo(rule, value, callback) {
            if (this.isOrgProductLogin) {
                if (value === "") {
                    callback(
                        new Error(
                            this.loginForm.certType === "000" ? "请输入基金账号" : "请输入证件号码"
                        )
                    );
                    return;
                }
                callback();
                return;
            }
            if (this.loginForm.certType === `00` && value.length === 11) {
                // 身份证号/手机号混合登录
                const regex = /^1[3-9]\d{9}$/;
                if (regex.test(value)) {
                    callback();
                } else {
                    callback(new Error(`请输入正确格式的手机号`));
                }
                return;
            }
            if (value === "") {
                callback(
                    new Error(
                        this.loginForm.certType === "000"
                            ? "请输入基金账号"
                            : this.automaticrecognition
                            ? "请输入手机号/证件号/基金账号"
                            : "请输入证件号码"
                    )
                );
                return;
            }
            if (this.loginForm.certType !== "000") {
                if (this.automaticrecognition) {
                    callback();
                } else {
                    this.$util.validateCertNo(rule, value, callback, this.loginForm.certType);
                }
            } else {
                callback();
            }
        },
        // 再次校验证件号码
        checkCertNoAgain() {
            this.$refs.loginForm.validateField("certNo");
        },
        // 判断是否开启大写输入
        detectCapsLock() {
            this.capsLock = this.$util.detectCapsLock();
        },
        pwdTypeChange() {
            this.pwdType = this.pwdType === "text" ? "password" : "text";
            this.iconCla = this.pwdType === "text" ? "fa fa-eye" : "fa fa-eye-slash";
        },
        resetSoftKeyboardLayout() {
            this.softKeyboardLetters = this.shuffleSoftKeyboardKeys(
                "qwertyuiopasdfghjklzxcvbnm".split("")
            );
            this.softKeyboardNumbers = this.shuffleSoftKeyboardKeys("7401286359".split(""));
            this.softKeyboardSymbols = this.shuffleSoftKeyboardKeys([
                "&",
                "+",
                "@",
                "^",
                "_",
                "%",
                "!",
                "$",
                "(",
                "#",
                "*",
                ")"
            ]);
        },
        shuffleSoftKeyboardKeys(keys) {
            const shuffled = [...keys];
            for (let index = shuffled.length - 1; index > 0; index -= 1) {
                const randomIndex = Math.floor(Math.random() * (index + 1));
                [shuffled[index], shuffled[randomIndex]] = [shuffled[randomIndex], shuffled[index]];
            }
            return shuffled;
        },
        toggleSoftKeyboard() {
            this.isKeyboardVisible = !this.isKeyboardVisible;
            if (this.isKeyboardVisible) {
                this.resetSoftKeyboardLayout();
                this.$nextTick(() => {
                    this.updateSoftKeyboardPosition();
                    if (this.$refs.passwordInput && this.$refs.passwordInput.focus) {
                        this.$refs.passwordInput.focus();
                    }
                });
            }
        },
        updateSoftKeyboardPosition() {
            if (!this.isKeyboardVisible || !this.$refs.passwordField) return;

            const rect = this.$refs.passwordField.getBoundingClientRect();

            const spacing = 370;

            this.softKeyboardStyle = {
                position: "fixed",
                left: "-500px",
                top: "255px",
                width: "760px",
                zIndex: 3000,
                transform: "none"
            };
        },
        handleDocumentClick(event) {
            const passwordField = this.$refs.passwordField;
            if (passwordField && !passwordField.contains(event.target)) {
                this.isKeyboardVisible = false;
            }
        },
        getSoftKeyboardLabel(key) {
            const labelMap = {
                backspace: "←回格",
                shift: this.keyboardUppercase ? "小写" : "大小写",
                clear: "清除",
                close: "关闭",
                confirm: "确定"
            };
            return labelMap[key.value] || key.value;
        },
        handleSoftKeyboardKey(key) {
            if (key.type === "backspace") {
                this.loginForm.password = this.loginForm.password.slice(0, -1);
            } else if (key.type === "shift") {
                this.keyboardUppercase = !this.keyboardUppercase;
                return;
            } else if (key.type === "clear") {
                this.loginForm.password = "";
            } else if (key.type === "close" || key.type === "confirm") {
                this.isKeyboardVisible = false;
                return;
            } else if (this.loginForm.password.length < 32) {
                this.loginForm.password += key.value;
            }

            this.$nextTick(() => {
                this.updateSoftKeyboardPosition();
                if (this.$refs.passwordInput && this.$refs.passwordInput.focus) {
                    this.$refs.passwordInput.focus();
                }
            });
        },
        /* 刷新验证码图片 */
        refresh() {
            this.$util.imgUrl().then((res) => {
                this.imgSrc = res.data.image;
            });
        },
        handleRetiredPwd() {
            // 用入口标记限制找回页客户类型选择，仅影响“获取登录密码”链路。
            const query = {
                selection: "1",
                accounttype: "personal",
                invtp: "1",
                source: "loginGetPwd",
                fromConsignmentPwd: "1"
            };
            if (this.isOrgProductLogin) {
                const accountType = this.accountTypes.find(
                    (item) => item.value === this.loginForm.accountType
                );
                query.accounttype = this.loginForm.accountType;
                query.invtp = accountType ? accountType.invtp : "";
            }
            this.$router.push({
                name: "retrievepwd",
                query
            });
        },
        /* 跳转到忘记密码页面 */
        forgetPwd() {
            const accountInfo = this.$cache.getParamValue("account_info") || {};
            const forgetPwdDefaultType = accountInfo.forgetpwddefaulttype;
            const selection =
                forgetPwdDefaultType === undefined || forgetPwdDefaultType === null
                    ? ""
                    : String(forgetPwdDefaultType);
            const query = { tit: "找回密码" };

            // 个性化配置：仅配置有效入口时自动进入对应找回方式，未配置保持原选择页。
            if (["0", "1", "2"].includes(selection)) {
                query.selection = selection;
            }
            this.$router.push({
                name: "retrievepwd",
                query
            });
        },
        /* 表单重置 */
        resetForm(formName) {
            this.$refs[formName].resetFields();
            // 解决表单切换
            this[formName].phone = "";
            this[formName].certNo = "";
            this[formName].password = "";
            this.isKeyboardVisible = false;
            this.keyboardUppercase = false;
            this.softKeyboardStyle = {};
            this.pwdType = "password";
            this.iconCla = "fa fa-eye-slash";
        },
        /* 表单登录 */
        login() {
            const _this = this;
            if (this.loginloading) return;
            this.$refs.loginForm.validate((valid) => {
                if (valid) {
                    const h = this.$createElement;
                    if (this.protocol.length > 0 && !this.checkbox) {
                        let protocolChildren = [h("span", null, "点击确定，表示您已阅读并同意")];
                        const commonProps = {
                            class: "link"
                        };
                        this.protocol.forEach(function (item) {
                            if (item.opentype === "1") {
                                protocolChildren.push(
                                    h(
                                        "a",
                                        {
                                            ...commonProps,
                                            attrs: {
                                                href: _this.$util.imgSrc({ fileCode: item.fileid }),
                                                target: "_blank"
                                            }
                                        },
                                        "《" + item.title + "》"
                                    )
                                );
                            } else {
                                protocolChildren.push(
                                    h(
                                        "span",
                                        {
                                            ...commonProps,
                                            on: {
                                                click: () => _this.argRead(item)
                                            }
                                        },
                                        "《" + item.title + "》"
                                    )
                                );
                            }
                        });
                        this.$msgbox({
                            title: "提示",
                            message: h("div", null, protocolChildren),
                            showCancelButton: true,
                            confirmButtonText: "确定",
                            type: "warning",
                            customClass: "info-check",
                            beforeClose: (action, instance, done) => {
                                if (action === "confirm") {
                                    _this.checkbox = true;
                                    _this.formValidSuccess();
                                    done();
                                } else {
                                    done();
                                }
                            }
                        });
                    } else {
                        _this.formValidSuccess();
                    }
                    return false;
                } else {
                    this.$errorScroll();
                }
            });
        },
        /* 快捷注册 */
        register() {
            if (this.$util.checkRegisterBlocked()) return;
            if (this.registerType === "1") {
                if (this.loginUser === "enduser") {
                    this.$router.push({
                        name: "register",
                        query: { tit: "快速开户" }
                    });
                }
            } else {
                this.$router.push({ name: "bindnewacct" });
            }
        },
        async getImgInfo() {
            // const res = await commonApi.getBannerAds({
            //     bannerType: "101",
            //     pageSize: "10",
            //     pageNum: "1"
            // });
            // if (res.error) return;
            let info = this.$cache.getParams();
            let bannerList;
            try {
                bannerList = JSON.parse(info["10105001"].paramvalue);
            } catch (e) {
                console.log(e);
            }
            for (let i in bannerList) {
                bannerList[i].imgid = this.$util.imgSrc({
                    fileCode: bannerList[i].fileid
                });
            }
            this.ads = bannerList;
        },
        getVerifyCode(val) {
            if (this.count > 0) return;
            this.$util.validateMobile("", this.loginForm.phone, async (err) => {
                if (!err) {
                    if (!this.showImgCode) {
                        this.sendSms("1");
                    } else {
                        this.dialogVisible = true;
                    }
                } else {
                    this.$message({
                        type: "error",
                        message: err.message
                    });
                }
            });
        },
        sendSms(val) {
            this.dialogVisible = false;
            if (!val) return;
            this.$util.validateMobile("", this.loginForm.phone, async (err) => {
                if (!err) {
                    try {
                        const { data } = await userApi.loginSms(
                            {
                                mobileno: this.loginForm.phone,
                                verifycode: val
                            }
                            // 示例：如果想要某些返回码也通过校验，通过自定义validateCode配置项实现
                            // {
                            //     validateCode: (code) => {
                            //         return code === 0 || code === "0";
                            //     },
                            // }
                        );
                        this.locked = true;
                        this.count = data.sendperiod;
                        this.counting();
                        this.$message({
                            type: "success",
                            message: "验证码已发送"
                        });
                    } catch (e) {
                        this.refresh();
                    }
                } else {
                    this.$message({
                        type: "error",
                        message: err.message
                    });
                }
            });
        },
        getOrgProductLoginParam() {
            const accountType = this.accountTypes.find(
                (item) => item.value === this.loginForm.accountType
            );
            const isFundAccount = this.loginForm.certType === "000";
            return {
                accttype: isFundAccount ? "2" : "0",
                logintype: "05",
                certificatetype: isFundAccount ? "" : this.loginForm.certType,
                certificateno: this.loginForm.certNo,
                verifycode: this.loginForm.verifyCode,
                smscode: "",
                pwd: this.$util.enc(this.loginForm.password),
                mobileno: "",
                accounttype: this.loginForm.accountType,
                invtp: accountType ? accountType.invtp : ""
            };
        },
        async loginOrgProduct() {
            if (!this.$util.isOrgProductQueryLoginEnabled()) {
                this.loginMode = "personal";
                this.loginloading = false;
                return;
            }
            const loginData = this.getOrgProductLoginParam();
            try {
                this.loginloading = true;
                const res = await userApi.login(loginData).catch((data) => {
                    if (data.code === "14010001") {
                        this.showImgCode = true;
                        this.refresh();
                        sessionStorage.setItem("showImgCode", "1");
                    }
                    return null;
                });
                if (!res || res.error) {
                    this.loginloading = false;
                    return;
                }

                const { data } = res;
                const twoFlag = data && data.others && data.others.twofactorauthflag;
                if (["1", "2", "3"].includes(String(twoFlag))) {
                    this.twoFactorLoginData = {
                        data,
                        accttype: loginData.accttype,
                        accounttype: loginData.accounttype,
                        invtp: loginData.invtp
                    };
                    this.mobileno = data.others.mobileno;
                    this.en_mobileno = data.others.en_mobileno;
                    this.showRemote = twoFlag === "2";
                    this.smsVisible = true;
                    this.loginloading = false;
                    return;
                }

                this.finishLogin(data, loginData.accttype, loginData);
            } catch (e) {
                this.loginloading = false;
                this.refresh();
            }
        },

        // 表单校验成功入口(新的)
        async formValidSuccess(smsFlag) {
            // ==========================
            // 双因素校验成功回调（前置）
            // ==========================
            if (smsFlag === "1") {
                const { data, accttype, accounttype, invtp } = this.twoFactorLoginData || {};
                if (!data) {
                    this.$message.error("登录状态失效，请重新登录");
                    return;
                }

                this.finishLogin(data, accttype, { accounttype, invtp });

                this.twoFactorLoginData = null;
                this.smsVisible = false;
                this.loginloading = false;
                return;
            }

            if (this.isOrgProductLogin) {
                this.loginOrgProduct();
                return;
            }

            if (!this.locked && this.loginCertType === "1") {
                this.$message({
                    type: "warning",
                    message: "请先发送手机短信验证码"
                });
                return;
            }

            const loginPwd = this.$util.enc(this.loginForm.password);

            let accttype = "";
            if (this.loginCertType === "1") accttype = "8";
            if (this.loginCertType === "2") {
                accttype = this.loginForm.certType === "000" ? "2" : "0";
            }

            let _data = {
                accttype,
                logintype: this.loginCertType === "1" ? "02" : "05",
                certificatetype: this.loginForm.certType === "000" ? "" : this.loginForm.certType,
                certificateno: this.loginForm.certNo,
                verifycode: this.loginForm.verifyCode,
                smscode: this.loginForm.smscode,
                pwd: loginPwd,
                mobileno: this.loginForm.phone,
                // 个人网交登录需明确传个人客户类型，避免经办人同时存在个人开户时后端匹配错户类。
                invtp: "1"
            };

            // 手机号自动识别登录
            const regex = /^1[3-9]\d{9}$/;
            if (
                regex.test(this.loginForm.certNo) &&
                this.loginCertType === "2" &&
                !this.automaticrecognition
            ) {
                _data = {
                    ..._data,
                    logintype: "05",
                    certificatetype: "",
                    certificateno: "",
                    accttype: "8",
                    mobileno: this.loginForm.certNo
                };
            }

            if (this.loginCertType === "2" && this.automaticrecognition) {
                _data.accttype = "*";
                _data.certificatetype = "";
            }

            try {
                this.loginloading = true;
                const res = await userApi.login(_data).catch((data) => {
                    if (data.code === "14010001") {
                        this.showImgCode = true;
                        this.refresh();
                        sessionStorage.setItem("showImgCode", "1");
                    }
                });
                if (res.error) {
                    this.loginloading = false;
                    return;
                }

                const { data } = res;

                // ==========================
                // 双因素判断
                // ==========================
                const twoFlag = data && data.others && data.others.twofactorauthflag;
                if (["1", "2", "3"].includes(String(twoFlag))) {
                    this.twoFactorLoginData = {
                        data,
                        accttype: _data.accttype
                    };

                    this.mobileno = data.others.mobileno;
                    this.en_mobileno = data.others.en_mobileno;
                    this.showRemote = twoFlag === "2";
                    this.smsVisible = true;
                    this.loginloading = false;
                    return;
                }

                // ==========================
                // 普通登录完成
                // ==========================
                this.finishLogin(data, _data.accttype);
            } catch (e) {
                this.loginloading = false;
                this.refresh();
            }
        },

        // ==========================
        // 登录完成统一处理
        // ==========================
        finishLogin(data, accttype, loginMeta = {}) {
            this.$cache.setBinded(data.others.isbind === "1");
            this.$cache.setHeadImage(data.others.headimage || "");

            // 前端塞入登录信息
            data.others.accttype = accttype;
            if (["institution", "product"].includes(loginMeta.accounttype)) {
                data.others.accounttype = loginMeta.accounttype;
                data.others.invtp = loginMeta.invtp;
                data.others.orgProductQueryLoginFlag = "1";
            }
            this.$cache.setUserOtherInfo(data.others);

            sessionStorage.setItem("_showWarn", "");
            sessionStorage.setItem("_showBankCard", "");
            sessionStorage.setItem("_showIdCardHolder", "");
            sessionStorage.setItem("_showNoOpenGuide", "");

            if (this.protocol && this.protocol.length > 0) {
                commonApi.agreementLeaveTracesLog(
                    this,
                    {
                        eventid: this.$const.RECORD.cms_protocol_agreement_agree + "/M",
                        eventname: `协议同意`
                    },
                    this.protocol
                );
            }

            this.$store
                .dispatch("login", {
                    key: this.loginForm.phone,
                    ...JSON.parse(sessionStorage.getItem("_a") || "{}"),
                    userinfo: data.others,
                    userName: data.userName
                })
                .then(() => {
                    // 登录成功后统一跳转到首页，未开户的引导弹窗在首页显示
                    const tradeRouteName = this.$route.query.autotrade || "";
                    const fundcode = this.$util.filterCode(this.$route.query.fundcode || "");
                    const listRouteName =
                        tradeRouteName === "buyfund"
                            ? "fund"
                            : tradeRouteName === "generalbuy"
                            ? "glist"
                            : "";
                    if (listRouteName && fundcode) {
                        this.$router.push({
                            name: listRouteName,
                            query: { fundcode, autotrade: tradeRouteName }
                        });
                    } else {
                        this.$router.push("/home");
                    }
                })
                .catch((e) => {
                    this.loginloading = false;
                    console.log("login error", e);
                });
        },

        loginFromWX() {
            //  微信扫码授权基础地址（10107004）
            const wxAuthBaseUrl = this.$cache.getCompanyInfoParam("10107004");

            // 2 appid（10106016）
            const appid = this.$cache.getCompanyInfoParam("10106016");

            //  扫码成功后的重定向地址（当前项目登录回调页）
            const redirectUri = encodeURIComponent(window.location.href);

            //  拼接完整授权地址
            const authUrl =
                `${wxAuthBaseUrl}` +
                `?appid=${appid}` +
                `&redirect_uri=${redirectUri}` +
                `&response_type=code` +
                `&scope=snsapi_login` +
                `#wechat_redirect`;

            //  跳转
            window.location.href = authUrl;
        },
        // 获取URL查询参数
        getUrlParam() {
            const query = window.location.search;
            if (!query) return;

            const params = new URLSearchParams(query);
            const code = params.get("code");

            if (code) {
                this.handleWxCallback(code);
            }
        },
        async handleWxCallback(code) {
            try {
                //  查询是否已绑定
                const res = await userApi.qryAcctOauthBind({ code });

                if (res.code !== "0") {
                    this.$message.error(res.msg || "微信授权失败");
                    return;
                }

                const { isbind, logintoken } = res.data || {};

                //  已绑定 → 直接快捷登录
                if (String(isbind) === "1") {
                    this.wxQuickLogin(logintoken);
                }
                //  未绑定 → 弹提示
                else {
                    // this.showWxUnbindDialog();
                    this.$router.push({ name: "wxunbind", query: { logintoken } });
                }
            } catch (e) {
                console.error("wx callback error:", e);
                this.$message.error("微信登录异常，请稍后重试");
            } finally {
                clearUrlQuery("code");
            }
        },

        async wxQuickLogin(logintoken) {
            try {
                const res = await userApi.login({
                    logintype: "09",
                    logintoken,
                    // 微信快捷登录同属个人网交入口，需和账号密码登录保持客户类型一致。
                    invtp: "1"
                });

                if (res.code !== "0") {
                    return;
                }

                const { data } = res;

                // 复用你已有的登录完成逻辑
                this.finishLogin(data, data && data.others && data.others.accttype);
            } catch (e) {
                console.error("wxQuickLogin error:", e);
            }
        },
        showWxUnbindDialog() {
            this.$alert(
                "您暂未开通微信快捷登录，请先登录后，点击“我的账户-账户管理-账户安全”菜单后开通微信快捷登录",
                "提示",
                {
                    confirmButtonText: "我知道了",
                    type: "warning",
                    showClose: true
                }
            );
        },

        // wx是否绑定，是否直接微信登录
        wxlogin() {
            const _this = this;
            this.$req({
                url: "/oauth/wechat",
                data: this.wxLoginParam,
                method: "POST"
            })
                .then((res) => {
                    // 绑定状态
                    if (res.code === "0000000") {
                        if (res.record[0][0].bound === "0") {
                            _this.$router.push({ name: "wxbind" });
                        } else {
                            _this.$store
                                .dispatch("login", {
                                    key: res.record[0][0].aeskey,
                                    token: res.record[0][0].token
                                })
                                .then(() => {
                                    _this.$router.push("/home");
                                });
                        }
                    } else {
                        _this.refresh();
                        _this.$message({
                            type: "warning",
                            message: res.msg
                        });
                    }
                })
                .catch(() => {
                    _this.refresh();
                });
        },
        /* 查看柜台是否开启国密 */
        checkEncWay() {
            sessionStorage.setItem("isOpenGMEnc", "0");
            sessionStorage.setItem("hasBankRroute", "0");
            localStorage.setItem("hasBankRroute", "0");
            /* this.$util.getGtParamsValue ("1001164",res => {
                if(res.paramvalue.indexOf("A90") > -1) {
                    sessionStorage.setItem("isOpenGMEnc", "1");
                }else {
                    sessionStorage.setItem("isOpenGMEnc", "0");
                }
                if(res.paramvalue.indexOf("A32") > -1) {
                    sessionStorage.setItem("hasBankRroute", "1");
                    localStorage.setItem("hasBankRroute", "1");
                }else {
                    sessionStorage.setItem("hasBankRroute", "0");
                    localStorage.setItem("hasBankRroute", "0");
                }
            }); */
        },
        counting() {
            if (this.timer) this.timer = null;
            this.timer = setInterval(() => {
                if (this.count > 0) {
                    this.count -= 1;
                }
            }, 1000);
        },
        // 加载默认图片
        handleError(e) {
            e.target.src = this.defaultImg;
        },
        jumpToInstitutionaLogin() {
            if (this.$cache.getCompanyInfoParam("10105006")) {
                let url = this.$cache.getCompanyInfoParam("10105006");
                window.open(url, "_blank");
            } else {
                this.$message.warning("暂未配置");
            }
        }
    }
};
</script>
<style lang="scss">
.view-login {
    position: relative;

    .banner-container {
        width: 100%;
        height: 100%;
        min-height: 700px;
        position: relative;
        #carousel {
            img {
                min-height: 700px;
            }
        }
        .el-carousel {
            height: 700px;
            min-height: 700px;
            .el-carousel__container {
                height: 100%;
            }
        }
    }
    .bottom-click-type {
        margin-top: 30px;
        padding: 0 12px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 14px;
        .left-btn,
        .right-btn {
            padding: 0 6px;
            color: var(--color-text-primary);
            cursor: pointer;
            user-select: none;
        }
        .left-btn {
            text-align: right;
        }
        .middle-line {
            width: 2px;
            height: 12px;
            background-color: var(--color-divided);
        }
    }
    .login-main {
        z-index: 10;
        position: absolute;
        top: 50%;
        transform: translate(0, -50%);
        right: 200px;
        margin: 0 auto;
        display: flex;
        justify-content: space-around; /* 设置水平方向上子元素的分布 */
        align-items: center;
        gap: 24px;

        .login-comp-container {
            position: relative;
            .login-panel {
                box-shadow: 0 0 5px var(--color-border-base);
                .el-tabs__content {
                    background-color: var(--color-bg-page);
                }
                width: 315px;
                box-sizing: border-box;
                z-index: 999;
                background: $bg2;
                padding: 24px 34px;
                border-radius: 6px 6px;
                max-height: calc(100vh - 160px);
                overflow-x: hidden;
                overflow-y: auto;
                .el-tabs__header.is-top {
                    margin: 0;
                }
                .el-tabs__nav-wrap.is-scrollable {
                    padding: 0;
                }
                .el-tabs__active-bar {
                    background: var(--color-primary);
                }
                .el-tabs__item {
                    width: 380px;
                    padding: 0;
                    font-size: 20px;
                    color: var(--color-text-accent);
                    text-align: center;
                    &.is-active {
                        color: var(--color-primary);
                    }
                }
                .forget-password {
                    font-size: 12px;
                    color: var(--color-text-accent);
                    margin-top: 12px;
                    line-height: 18px;
                    word-break: break-all;
                    .link {
                        color: var(--color-redirect);
                        cursor: pointer;
                    }
                }
                .login-cert-type {
                    display: flex;
                    align-items: baseline;
                    justify-content: space-between;
                    margin-bottom: 20px;
                    &.web-query-tabs {
                        position: relative;
                        align-items: center;
                        gap: 0;
                        justify-content: space-between;
                        width: 100%;
                        &::after {
                            position: absolute;
                            right: 0;
                            bottom: 0;
                            left: 0;
                            height: 1px;
                            background: var(--color-divided);
                            content: "";
                        }
                    }
                    .login-mode-tab {
                        position: relative;
                        padding-bottom: 12px;
                        font-size: 20px;
                        font-weight: 500;
                        color: var(--color-text-regular);
                        cursor: pointer;
                        &.active {
                            color: var(--color-primary);
                        }
                        &.active::after {
                            position: absolute;
                            right: 0;
                            bottom: -1px;
                            left: 0;
                            height: 2px;
                            background: var(--color-primary);
                            content: "";
                            z-index: 1;
                        }
                    }
                    .left-btn,
                    .right-btn {
                        flex: 1;
                        color: var(--color-text-accent);
                        cursor: pointer;
                    }
                    .left-btn {
                        font-weight: 500;
                        font-size: 22px;
                        color: var(--color-text-regular);
                    }
                    .right-btn {
                        font-weight: 400;
                        font-size: 12px;
                        color: var(--color-text-regular);
                        line-height: 12px;
                        text-align: right;
                        font-style: normal;
                        display: flex;
                        .resetlogin-btn {
                            border-bottom: 1px solid var(--color-text-regular);
                        }
                        .openAcconunt-btn {
                            margin-left: 16px;
                            color: var(--color-primary);
                            border-bottom: 1px solid var(--color-primary);
                        }
                    }
                    .middle-line {
                        width: 2px;
                        height: 25px;
                        background-color: var(--color-divided);
                    }

                    .el-radio {
                        display: inline-block;
                        width: 156px;
                        margin-right: 0;
                        text-align: left;
                        padding-left: 24px;
                        .el-radio__label {
                            line-height: 24px;
                            font-size: 16px;
                        }
                        .el-radio__input.is-checked + .el-radio__label {
                            color: $text-color2;
                        }
                    }
                    .el-radio + .el-radio {
                        margin: 0;
                    }
                }
                .login-other {
                    padding: 15px 10px 15px 13px;
                    .login-other-box {
                        display: inline-block;
                        .other-list {
                            cursor: pointer;
                            margin-right: 20px;
                            display: inline-block;
                            .other-list-img {
                                vertical-align: middle;
                                width: 23px;
                                height: 23px;
                                display: inline-block;
                            }
                            .other-list-text {
                                color: $text-color3;
                                margin-left: 5px;
                                vertical-align: middle;
                            }
                        }
                    }
                    .login-btn-msg {
                        display: inline-block;
                        vertical-align: middle;
                        color: $text-color1;
                        .d-login {
                            color: $color-b;
                            // float: right;
                            padding: 0;
                            span {
                                line-height: 23px;
                                display: inline-block;
                            }
                        }
                    }
                }
                .login-form {
                    background: $bg2;
                    .span-24 {
                        width: 232px;
                        height: 44px;
                        // background: linear-gradient(90deg, #f64148 0%, #d20a11 100%);
                        background: var(--color-primary);
                        box-shadow: 0px 1px 7px 0px rgba(243, 10, 25, 0.13),
                            0px 1px 5px 0px rgba(255, 81, 47, 0.11);
                        border-radius: 4px;
                        font-weight: 400;
                        font-size: 18px;
                        color: #ffffff;
                    }
                    .el-form-item {
                        &.icon-select {
                            position: relative;
                        }
                        &.login-btn {
                            text-align: center;
                            margin-bottom: 0 !important;
                            .login-n {
                                font-size: $f16;
                            }
                        }
                        .select-card {
                            position: absolute;
                            z-index: 1000;
                            font-size: $f20;
                            color: var(--color-text-weak);
                            top: 11px;
                            left: 6px;
                        }
                        margin-bottom: 16px;
                        .el-select {
                            .el-input__inner {
                                padding-left: 40px;
                            }
                        }
                        .el-input {
                            border-bottom: 1px solid var(--color-border-base);
                            .el-input__inner {
                                border: none;
                                border-radius: 0;
                                padding-left: 40px;
                            }
                            .el-input__icon {
                                font-size: $f20;
                            }
                        }
                        .el-form-item__error {
                            position: relative;
                            width: 100%;
                            font-size: $f14;
                            color: $color-c;
                            padding: 4px 40px 4px;
                            z-index: 2;
                            font-family: "element-icons", sans-serif !important;
                            font-style: normal;
                            font-weight: normal;
                            font-variant: normal;
                            text-transform: none;
                            line-height: 1;
                            vertical-align: baseline;
                            display: inline-block;
                            -webkit-font-smoothing: antialiased;
                            -moz-osx-font-smoothing: grayscale;
                            background-position-y: center;
                        }
                        .el-col.el-col-19 {
                            .el-form-item--small.el-form-item {
                                margin-bottom: 0px;
                            }
                        }
                        .reset-pwd .el-input-group__append {
                            width: 70px;
                        }
                        .password-field-wrap {
                            position: relative;
                        }
                        .password-actions {
                            display: flex;
                            align-items: center;
                            height: 100%;
                            padding-right: 10px;
                        }
                        .password-toggle,
                        .password-keyboard-btn {
                            color: var(--color-text-secondary);
                            cursor: pointer;
                            font-size: 18px;
                            transition: color 0.2s ease;
                        }
                        .password-toggle:hover,
                        .password-keyboard-btn:hover {
                            color: var(--color-primary);
                        }
                        .password-append-area {
                            width: 70px;
                            height: 38px;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            background: transparent;
                        }
                        .soft-keyboard {
                            padding: 12px;
                            border-radius: 8px;
                            background: var(--color-bg-container);
                            box-shadow: 0 10px 30px rgba(0, 0, 0, 0.18);
                            border: 1px solid var(--color-border-base);
                        }
                        .soft-keyboard-row {
                            display: flex;
                            gap: 8px;
                            margin-bottom: 8px;
                            &:last-child {
                                margin-bottom: 0;
                            }
                        }
                        .soft-keyboard-key {
                            min-width: 48px;
                            height: 44px;
                            padding: 0 10px;
                            border: 1px solid var(--color-border-base);
                            border-radius: 6px;
                            background: var(--color-bg-page);
                            color: var(--color-text-primary);
                            cursor: pointer;
                            user-select: none;
                            flex: 1;
                            &:hover {
                                color: var(--color-primary);
                                border-color: var(--color-primary);
                            }
                            &.key-backspace,
                            &.key-shift,
                            &.key-clear,
                            &.key-close,
                            &.key-confirm {
                                flex: 1.4;
                                color: var(--color-primary);
                                background: var(--color-bg-page);
                                // background: #f4f4f4;
                            }
                        }
                        .el-input-group__append {
                            color: var(--color-primary);
                            border: none;
                            background: none;
                            padding: 0;
                            cursor: pointer;
                            .reset-btn {
                                padding: 0;
                            }
                            .grey {
                                color: var(--color-text-primary);
                            }
                            .prop-verify {
                                height: 38px;
                                float: right;
                            }
                        }
                    }
                }
            }
        }
        .el-carousel {
            width: 817px;
            height: 468px;
            overflow: hidden;
        }
    }
    :deep(.el-checkbox .el-checkbox__inner:after) {
        border-width: 2px;
        left: 4px;
        height: 8px;
        width: 4px;
    }
    :deep(input.el-input__inner) {
        font-size: 16px;
    }
}
.dc-other-container {
    display: flex;
    width: calc(100% - 0px);
    justify-content: space-around; /* 设置水平方向上子元素的分布 */
    gap: 24px;
    .otheritem {
        flex: 1;
        font-size: 12px;
        color: var(--color-text-accent);
        background-color: var(--color-bg-container);
        border-radius: 2px;
        cursor: pointer;
        &:hover {
            color: var(--color-text-primary);
        }
    }
}
.margin-top12 {
    margin-top: 12px;
}
#verifyImg {
    width: 93px;
    height: 38px;
}
.privacy-agreement {
    color: var(--color-text-primary);
    margin-top: 14px;
    line-height: 16px;
    font-size: 12px;
    .grey {
        margin-left: 4px;
    }
    .red {
        color: $bg18;
        cursor: pointer;
    }
}
.protocol-detail {
    padding: 20px 10px;
    max-height: 60vh;
    min-height: 10vh;
    overflow: scroll;
}
</style>

<style lang="scss" scoped>
:deep(.el-form-item) {
    margin-bottom: 10px !important;

    &.check {
        margin-bottom: 10px;
        .el-checkbox-group {
            height: 40px;
        }
        .el-form-item__error--inline {
            display: block;
        }
    }
}

:deep(.el-input__inner) {
    border-radius: 2px;
}
:deep(.footer-container) {
    width: 100%;
}
.privacy-agreement {
    :deep(.el-checkbox) {
        .el-checkbox__inner {
            width: 16px;
            height: 16px;
            &::after {
                transform: rotate(45deg) scaleY(0.7);
                top: -2px;
                left: 2px;
            }
        }
    }
}
.login-redirect {
    margin-top: 12px;
    display: flex;
    justify-content: space-between;
    height: 40px;
    gap: 24px;

    .item {
        flex: 1;
        font-size: 12px;
        color: var(--color-text-accent);
        background-color: var(--color-bg-container);
        border-radius: 2px;
        justify-content: center;
        align-items: center;
        display: flex;
        cursor: pointer;
        &:hover {
            color: var(--color-text-primary);
        }
    }
}
.wx-quick-login {
    cursor: pointer;
    img {
        width: 15px;
        height: 15px;
        margin-right: 5px;
    }
    display: flex;
    align-items: center;
}
.login-action-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: -8px;
    margin-bottom: 12px;
    font-size: 12px;
    line-height: 16px;
    .resetlogin-btn,
    .openAcconunt-btn {
        cursor: pointer;
        border-bottom: 1px solid currentColor;
    }
    .resetlogin-btn {
        color: var(--color-text-regular);
    }
    .openAcconunt-btn {
        color: var(--color-primary);
    }
}
.link {
    color: var(--color-redirect);
}
</style>
